import { useState } from 'react';
import { useSelector } from 'react-redux';
import { useProgressSuccess } from 'hooks';
import * as selectors from '../../selectors';
const useConfirmEmailSteps = (isMinorMock)=>{
    const initialStep = isMinorMock ? 'ConfirmTermsOfServicesByGuardian' : 'VerifyCode';
    const [currentViewName, setCurrentViewName] = useState(initialStep);
    const isEditGuardianEmailInProgress = useSelector(selectors.isEditGuardianEmailInProgress);
    const hasEditGuardianEmailErrors = useSelector(selectors.hasEditGuardianEmailErrors);
    const onSuccess = ()=>{
        setCurrentViewName('ConfirmTermsOfServicesByGuardian');
    };
    useProgressSuccess(isEditGuardianEmailInProgress, hasEditGuardianEmailErrors, onSuccess);
    return {
        currentViewName,
        onEditGuardianEmail: ()=>setCurrentViewName('EditGuardianEmail'),
        onConfirmationCompleted: ()=>setCurrentViewName('VerifyCode')
    };
};
export default useConfirmEmailSteps;
